import React, { useMemo } from "react";
import { buildTcpaElement } from "../utils/tcpa";
import { FormReducerAction, Operation } from "../types";
import { DomainInfo } from "src/api/domainInfo";
import { DomainForm } from "src/api/domainForm";
import { Step } from "@lib/shared/types";

export interface UseFormTcpaParams {
    isSecondServiceForm: boolean | undefined;
    isSecondServiceSelected: boolean;
    showTCPAMessage: boolean;
    formErrors: unknown;
    operation: Operation | null | undefined;
    domain: DomainInfo;
    finalForm: DomainForm;
    steps: Step[];
    currentStep: number;
    classes?: { tcpaClassName?: string };
    submitButtonText: string | undefined;
    dispatch: React.Dispatch<FormReducerAction>;
    isFormInsideOffersModal: boolean;
}

export function useFormTcpa({
    isSecondServiceForm,
    isSecondServiceSelected,
    showTCPAMessage,
    formErrors,
    operation,
    domain,
    finalForm,
    steps,
    currentStep,
    classes,
    submitButtonText,
    dispatch,
    isFormInsideOffersModal,
}: UseFormTcpaParams): React.ReactElement | undefined {
    return useMemo(
        () =>
            buildTcpaElement({
                isSecondServiceForm,
                isSecondServiceSelected,
                showTCPAMessage,
                formErrors,
                operation,
                domain,
                finalForm,
                steps,
                currentStep,
                classes,
                submitButtonText,
                dispatch,
            }),
        [
            isSecondServiceForm,
            isSecondServiceSelected,
            showTCPAMessage,
            formErrors,
            isFormInsideOffersModal,
            currentStep,
            submitButtonText,
            domain,
            operation,
        ],
    );
}
